import {
  afterNextRender,
  DestroyRef,
  Directive,
  ElementRef,
  inject,
  Input,
} from '@angular/core';

@Directive({
  selector: '[emcAutoScroll]',
})
export class AutoScrollDirective {
  private el = inject(ElementRef<HTMLElement>);
  private destroyRef = inject(DestroyRef);

  // @Input('emcScrollDuration') duration: number = 40;

  constructor() {
    // afterNextRender(() => {
      this.init();
    // });
  }

  private init() {
    const element = this.el.nativeElement;
    const parent = element.parentElement;
    if (!parent) return;

    const resizeObserver = new ResizeObserver(() => {
      this.calculate();
    });

    resizeObserver.observe(element);

    this.destroyRef.onDestroy(() => {
      resizeObserver.disconnect();
    });

    this.calculate();
  }

  private calculate() {
    const element = this.el.nativeElement;
    const parent = element.parentElement;
    if (!parent) return;

    const totalHeight = element.scrollHeight;
    const clientHeight = parent.clientHeight;
    const scrollDistance = clientHeight - totalHeight > 0 ? 0 : clientHeight - totalHeight;

    element.style.setProperty('--scroll-distance', `${scrollDistance}px`);
    // element.style.animationDuration = `${this.duration}s`;
  }
}
